import { zodResolver } from '@hookform/resolvers/zod';
import { useWebgate } from '@xvia/webgate-connect';
import React from 'react';
import { useForm, SubmitHandler } from 'react-hook-form';
import { z } from 'zod';

import { useSendNotification } from '@hooks/notification/useSendNotification';

import { Notification } from './Notification';

export interface FormValues {
  cpf: string;
  message: string;
}

export interface FeedbackProps {
  type: 'success' | 'error';
  message: string;
}

const schema = z.object({
  cpf: z.string().refine((val) => val.length === 11, { message: 'O CPF deve ter 11 dígitos.' }),
  message: z.string().min(1, { message: 'A mensagem é obrigatória' }),
});

export const NotificationContainer: React.FC = () => {
  const { accessToken } = useWebgate();
  const [feedback, setFeedback] = React.useState<FeedbackProps | null>(null);

  const { mutate: sendNotification, isPending } = useSendNotification(accessToken ?? '');

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm<FormValues>({
    resolver: zodResolver(schema),
  });

  const onSubmit: SubmitHandler<FormValues> = ({ cpf, message }) => {
    sendNotification(
      { recipientCpf: cpf, messageContent: message },
      {
        onSuccess: () => {
          setFeedback({ type: 'success', message: 'Notificação enviada com sucesso!' });
          reset();
        },
        onError: (error) => {
          console.error('Erro ao enviar a notificação:', error);
          setFeedback({ type: 'error', message: 'Falha ao enviar a notificação. Tente novamente.' });
        },
      },
    );
  };

  const onCloseFeedback = () => {
    setFeedback(null);
  };

  return (
    <Notification
      onSubmit={handleSubmit(onSubmit)}
      register={register}
      errors={errors}
      feedback={feedback}
      onCloseFeedback={onCloseFeedback}
      isAuthenticated={!!accessToken}
      isPending={isPending}
    />
  );
};
